"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./");
const getCampaignType_1 = require("../views/utils/getCampaignType");
const getCampaignType_2 = require("./../views/utils/getCampaignType");
const index_1 = require("./index");
const formatDateTime_1 = require("../views/utils/formatDateTime");
const isEqual = require('lodash/isEqual');
exports.default = (state = null, action) => {
    if (action.editableCampaign) {
        return Object.assign({}, action.editableCampaign);
    }
    return state;
};
exports.shouldCreateEditableCampaign = (state) => state === null;
exports.getEditableCampaign = (state) => state.editableCampaign;
exports.getShouldShowSaveAndClose = (state) => {
    const { editableCampaign, editableUIState } = state;
    const { id } = editableCampaign;
    const campaign = _1.getCampaign(state, id);
    const { name: campaignName, UIState, updatedAt } = campaign, campaignFields = __rest(campaign, ["name", "UIState", "updatedAt"]);
    const { name: editableCampaignName, updatedAt: updateDate } = editableCampaign, editableCampaignFields = __rest(editableCampaign, ["name", "updatedAt"]);
    const nextTriggeredShowSaveAndClose = () => Object.keys(editableUIState).some((page) => editableUIState[page].seen &&
        (UIState.length === 0 || !JSON.parse(UIState)[page].seen));
    const isPublishedCampaignSettingsValid = () => {
        const currentWizard = index_1.getCurrentWizard(state);
        return index_1.getIsStageValid(editableCampaign, editableUIState, currentWizard);
    };
    const segment = _1.getEditableCampaignSegment(state);
    if (segment && segment.__typename === 'DeviceListSegment' && !segment.deviceList.id) {
        return false;
    }
    if (campaign.status === 'PUBLISHED' && !isPublishedCampaignSettingsValid()) {
        return false;
    }
    if (getCampaignType_2.isAPICampaignTrigger(campaign.trigger)) {
        return !isEqual(editableCampaignFields, campaignFields) || nextTriggeredShowSaveAndClose();
    }
    return !isEqual(editableCampaignFields, campaignFields) || nextTriggeredShowSaveAndClose();
};
exports.getDisplayTime = (state) => {
    const { editableCampaign: { trigger }, } = state;
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
        const { dateTime } = trigger;
        if (!dateTime) {
            return '';
        }
        return dateTime.time === null ? '' : formatDateTime_1.formatDisplayTime(dateTime.time);
    }
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        const { eventTrigger: { filters }, } = trigger;
        const timeOfDayFilter = filters.find((f) => f.__typename === 'TimeOfDayEventTriggerFilter');
        if (timeOfDayFilter && getCampaignType_1.isTimeOfDayEventTriggerFilter(timeOfDayFilter)) {
            const { startTime, endTime } = timeOfDayFilter;
            if (startTime == null && endTime == null) {
                return '';
            }
            if (startTime && endTime == null) {
                return `After ${formatDateTime_1.formatDisplayTime(startTime)}`;
            }
            if (startTime == null && endTime) {
                return `Before ${formatDateTime_1.formatDisplayTime(endTime)}`;
            }
            return `Between ${formatDateTime_1.formatDisplayTime(startTime)} and ${formatDateTime_1.formatDisplayTime(endTime)}`;
        }
        return '';
    }
};
exports.getEditableCampaignDayOfWeekDisplayName = (state) => {
    const { editableCampaign: { trigger }, } = state;
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        const { eventTrigger: { filters }, } = trigger;
        const daysOfWeek = filters.find((f) => f.__typename === 'DayOfTheWeekEventTriggerFilter');
        if (!daysOfWeek || !getCampaignType_1.isDayOfTheWeekEventTriggerFilter(daysOfWeek)) {
            return '';
        }
        const selectedDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].filter((day) => daysOfWeek[day]);
        const isWeekday = (day) => ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].includes(day);
        const isWeekend = (day) => ['saturday', 'sunday'].includes(day);
        if (selectedDays.filter((day) => isWeekday(day)).length === 0 &&
            selectedDays.filter((day) => isWeekend(day)).length === 2) {
            return 'Weekends';
        }
        if (selectedDays.filter((day) => isWeekday(day)).length === 5 &&
            selectedDays.filter((day) => isWeekend(day)).length === 0) {
            return 'Weekdays';
        }
        if (Object.values(daysOfWeek)
            .filter((v) => v !== 'DayOfTheWeekEventTriggerFilter')
            .filter((v) => v).length === 7) {
            return 'Every day';
        }
        const daysArr = Object.keys(daysOfWeek)
            .filter((v) => v !== 'DayOfTheWeekEventTriggerFilter')
            .filter((day) => daysOfWeek[day])
            .filter((day) => day !== '__typename')
            .map((day) => day[0].toUpperCase() + day.slice(1));
        const str = daysArr.join(', ');
        const lastComma = str.lastIndexOf(',');
        return str.substr(0, lastComma) + (daysArr.length > 1 ? ' and ' : '') + str.substr(lastComma + 1);
    }
};
exports.getFormatDate = (state) => {
    const editableCampaign = exports.getEditableCampaign(state);
    const { trigger } = editableCampaign;
    let date;
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
        date = trigger.dateTime ? trigger.dateTime.date : null;
    }
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        const scheduledTrigger = trigger.eventTrigger.filters.find((f) => f.__typename === 'ScheduledEventTriggerFilter');
        if (scheduledTrigger && getCampaignType_1.isScheduledEventTriggerFilter(scheduledTrigger)) {
            date = scheduledTrigger.startDateTime ? scheduledTrigger.startDateTime.date : null;
        }
    }
    return formatDateTime_1.formatDate(date);
};
exports.getFormattedAutomatedEndDate = (state) => {
    const filter = exports.getEditableCampaignScheduledEventTriggerFilter(state);
    if (filter) {
        if (filter.endDateTime && filter.endDateTime.date) {
            return formatDateTime_1.formatDate(filter.endDateTime.date);
        }
    }
    return;
};
exports.getEditableCampaignFrequencyLimits = (state) => {
    const editableCampaign = exports.getEditableCampaign(state);
    const { trigger } = editableCampaign;
    if (getCampaignType_2.isAPICampaignTrigger(trigger) || getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        return trigger.limits;
    }
    return [];
};
exports.getAutomatedLimitType = (state) => {
    const { trigger } = exports.getEditableCampaign(state);
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        const { limits = [] } = trigger;
        if (limits.length === 0) {
            return 'An unlimited amount';
        }
        if (limits.find(({ count, interval }) => count === 1 && !interval)) {
            return 'Only once';
        }
        return 'No more than...';
    }
};
exports.getEditableCampaignDeliverable = (state) => {
    const editableCampaign = exports.getEditableCampaign(state);
    if (editableCampaign) {
        return editableCampaign.deliverable;
    }
};
exports.getEditableCampaignTrigger = (state) => {
    const editableCampaign = exports.getEditableCampaign(state);
    if (editableCampaign) {
        return editableCampaign.trigger;
    }
};
exports.getEditableCampaignScheduledCampaignTrigger = (state) => {
    const trigger = exports.getEditableCampaignTrigger(state);
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
        return trigger;
    }
};
exports.getEditableCampaignAutomatedCampaignTrigger = (state) => {
    const trigger = exports.getEditableCampaignTrigger(state);
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        return trigger;
    }
};
exports.getEditableCampaignEventTrigger = (state) => {
    const trigger = exports.getEditableCampaignAutomatedCampaignTrigger(state);
    if (trigger) {
        return trigger.eventTrigger;
    }
};
exports.getEditableCampaignEventTriggerFilters = (state) => exports.getEditableCampaignEventTrigger(state).filters || [];
exports.getEditableEventAttributesEventTriggerFilter = (state) => {
    const eventTrigger = exports.getEditableCampaignEventTrigger(state);
    if (eventTrigger) {
        const eventAttributeTrigger = _1.getEventTriggerFilterByType(eventTrigger.filters, 'EventAttributesEventTriggerFilter');
        if (eventAttributeTrigger) {
            return eventAttributeTrigger.predicate;
        }
    }
};
exports.getEditableCampaignScheduledEventTriggerFilter = (state) => {
    const eventTrigger = exports.getEditableCampaignEventTrigger(state);
    if (eventTrigger) {
        const scheduledEventTrigger = _1.getEventTriggerFilterByType(eventTrigger.filters, 'ScheduledEventTriggerFilter');
        if (scheduledEventTrigger) {
            return scheduledEventTrigger;
        }
    }
};
exports.getEditableCampaignTimeOfDayEventTriggerFilter = (state) => {
    const eventTrigger = exports.getEditableCampaignEventTrigger(state);
    if (eventTrigger) {
        const timeOfDayEventTrigger = _1.getEventTriggerFilterByType(eventTrigger.filters, 'TimeOfDayEventTriggerFilter');
        if (timeOfDayEventTrigger) {
            return timeOfDayEventTrigger;
        }
    }
};
exports.getEditableCampaignDayOfTheWeekEventTriggerFilter = (state) => {
    const eventTrigger = exports.getEditableCampaignEventTrigger(state);
    if (eventTrigger) {
        const dayOfTheWeekEventTrigger = _1.getEventTriggerFilterByType(eventTrigger.filters, 'DayOfTheWeekEventTriggerFilter');
        if (dayOfTheWeekEventTrigger) {
            return dayOfTheWeekEventTrigger;
        }
    }
};
exports.getEditableCampaignDeliverableTapBehavior = (state) => {
    const { tapBehavior } = exports.getEditableCampaignDeliverable(state);
    return tapBehavior;
};
